// Generated copies belong to the Study host and first-party embedded tools.
export type SurfaceAction = 'condition_changed' | 'control_activated' | 'simulation_manipulated' | 'answer_submitted'

/** Observe controls after their DOM mounts, including non-composed Shadow DOM events. Never read input values. */
export function observeToolSurface(host: Element, onReady: () => void, onAction: (action: SurfaceAction) => void) {
  const root = host.shadowRoot ?? host
  let ready = false
  const seen = new WeakSet<Event>()
  const scan = () => {
    if (!ready && [...root.querySelectorAll('input:not(:disabled),select:not(:disabled),button:not(:disabled),canvas,article')]
      .some((element) => !element.closest('header,nav,[data-usage-ignore]'))) {
      ready = true
      onReady()
    }
  }
  const interaction = (event: Event) => {
    if (!ready || seen.has(event)) return
    seen.add(event)
    const target = event.composedPath().find((item): item is Element => item instanceof Element)
    if (!target || target.closest('header,nav,[data-usage-ignore],[data-study-semantic]')) return
    let action: SurfaceAction | null = null
    if (event.type === 'change' && target.matches('input,select,textarea')) action = 'condition_changed'
    const button = target.closest<HTMLButtonElement>('button:not(:disabled)')
    if (event.type === 'click' && button && !(button.type === 'submit' && button.form)) action = 'control_activated'
    if (event.type === 'pointerup' && target.closest('canvas,svg,[data-study-manipulation]')) action = 'simulation_manipulated'
    if (event.type === 'submit') action = 'answer_submitted'
    if (action) onAction(action)
  }
  const kinds = ['change', 'click', 'pointerup', 'submit']
  for (const kind of kinds) root.addEventListener(kind, interaction, true)
  const observer = new MutationObserver(scan)
  observer.observe(root, { childList: true, subtree: true })
  scan()
  return () => {
    ready = false
    observer.disconnect()
    for (const kind of kinds) root.removeEventListener(kind, interaction, true)
  }
}
